// extracted by mini-css-extract-plugin
module.exports = {"learnDetailsContent":"PageContent-module--learn-details-content--3oCKD"};